var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 533.5,
    height: 544.3,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 402,
    width: 582,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    fill: "#ffffff",
    d: "m533.5,278.4c0,-18.5 -1.5,-37.1 -4.7,-55.3l-256.7,0l0,104.8l147,0c-6.1,33.8 -25.7,63.7 -54.4,82.7l0,68l87.7,0c51.5,-47.4 81.1,-117.4 81.1,-200.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "#ffffff",
    d: "m272.1,544.3c73.4,0 135.3,-24.1 180.4,-65.7l-87.7,-68c-24.4,16.6 -55.9,26 -92.6,26c-71,0 -131.2,-47.9 -152.8,-112.3l-90.5,0l0,70.1c46.2,91.9 140.3,149.9 243.2,149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    fill: "#ffffff",
    d: "m119.3,323.3c-11.4,-33.8 -11.4,-70.4 0,-104.2l0,-70.1l-90.4,0c-38.6,76.9 -38.6,167.5 0,244.4l90.4,-70.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    fill: "#ffffff",
    d: "m272.1,107.7c38.8,-0.6 76.3,14 104.4,40.8l77.7,-77.7c-49.2,-46.2 -114.5,-71.6 -182.1,-70.8c-102.9,0 -197,58 -243.2,150l90.4,70.1c21.5,-64.5 81.8,-112.4 152.8,-112.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGoogle);
export default __webpack_public_path__ + "static/media/logo_google.fb67f261540ada49d209a114b6a9b613.svg";
export { ForwardRef as ReactComponent };